import { dashboardRoutes } from './dashboardRoutes'
import { employeeRoutes } from './employeeRoutes'
import { userRoutes } from './userRoutes'
import { companyRoutes } from './companyRoutes'
import { costCenterRoutes } from './costCenterRoutes'
import { projectRoutes } from './projectRoutes'
import { usagePolicyRoutes } from './usagePolicyRoutes'
import { creditPolicyRoutes } from './creditPolicyRoutes'
import { reportRoutes } from './reportRoutes'
import { financialRoutes } from './financialRoutes'
import { searchPhoneRoutes } from './searchPhoneRoutes'
import { requestTokenRoutes } from './requestTokenRoutes'
import { webCallRoutes } from './webCallRoutes'
import { miscellaneousRoutes } from './miscellaneousRoutes'

export const privateRoutes = [
  ...userRoutes,
  ...dashboardRoutes,
  ...employeeRoutes,
  ...companyRoutes,
  ...costCenterRoutes,
  ...projectRoutes,
  ...usagePolicyRoutes,
  ...creditPolicyRoutes,
  ...reportRoutes,
  ...financialRoutes,
  ...searchPhoneRoutes,
  ...requestTokenRoutes,
  ...webCallRoutes,
  ...miscellaneousRoutes
]
